export const GTM_USER_TYPES = {
  CREATOR: 'CREATOR',
  BRAND: 'BRAND',
};
